import Image from 'next/image'
import Link from 'next/link'
import PropTypes from 'prop-types'
import { prop, sort, sortBy } from 'ramda'

import Button from 'components/Button'
import Debug from 'components/Debug'
import Spacer from 'components/Spacer'
import Text from 'components/Text'

import { ImageWrapper, Meta, OriginalQuantity, Root } from './CustomerOrderLineItem.style'
import BlankImage from './svg/blank_image.svg'
import CustomImage from './svg/custom_image.svg'

const findImageByColorID = ({ colorId, images }) => {
  if (!colorId) return images?.[0]

  const matchingImages = images.filter((image) => image.colorId === colorId).sort((a, b) => a.position - b.position)
  return matchingImages?.[0] || images?.[0]
}

const CustomerOrderLineItem = ({ lineItem }) => {
  const sku = lineItem?.sku || {}
  const product = sku?.product || {}
  const image = findImageByColorID({ colorId: sku.color?.id, images: product?.images })
  const isBespoke = product?.isSpecialOrder
  const linkPath = product.isOnline && `/products/${product.handle}`

  return (
    <Root>
      <ImageWrapper as={linkPath ? Link : 'div'} href={linkPath}>
        {isBespoke && <CustomImage width={150} height={150} />}
        {!isBespoke && !image && <BlankImage width={150} height={150} />}
        {!isBespoke && image && <Image src={image.urlThumb} width={150} height={150} alt={product.name} />}
      </ImageWrapper>
      <div>
        {linkPath ? (
          <Link href={`/products/${product.handle}`} className="text-gold hover:underline">
            <Text>{product.name}</Text>
          </Link>
        ) : (
          <Text>{product.name}</Text>
        )}
        <Spacer y={2} />
        <Meta>
          <table>
            <tbody>
              <tr>
                <th>
                  <Text>Color:</Text>
                </th>
                <td>
                  <Text>{sku?.color?.name || '-'}</Text>
                </td>
              </tr>
              <tr>
                <th>
                  <Text>Size:</Text>
                </th>
                <td>
                  <Text>{sku?.size?.name || '-'}</Text>
                </td>
              </tr>
              <tr>
                <th>
                  <Text>Quantity:</Text>
                </th>
                <td>
                  {lineItem.qtyReturned > 0 ? (
                    <>
                      <OriginalQuantity>
                        <Text>
                          <strike>{lineItem.quantity}</strike>{' '}
                        </Text>
                      </OriginalQuantity>
                      <Text>{lineItem.quantity - lineItem.qtyReturned}</Text>
                    </>
                  ) : (
                    <>
                      <Text>{lineItem.quantity}</Text>
                    </>
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </Meta>
      </div>
    </Root>
  )
}

CustomerOrderLineItem.propTypes = {
  lineItem: PropTypes.object,
}

CustomerOrderLineItem.defaultProps = {}

export default CustomerOrderLineItem
